import { useEffect, useRef } from 'react';
import { useGlobalState } from '@/hooks/useGlobalState';
import { GlobalAction } from '@/global/globalState';
import { useUserAccess } from '@/hooks/useUserAccess';

/**
 * On start, signs the person back in when the browser still holds their B2C sign-in
 * (MSAL's cache), so a reload keeps them signed in. Renders nothing; does nothing
 * without B2C settings or when someone is already signed in.
 */
export function SessionRestore() {
  const { access, available, restore } = useUserAccess();
  const tried = useRef(false);
  const { dispatch } = useGlobalState();

  useEffect(() => {
    if (tried.current) return;
    tried.current = true;
    const ready = () => dispatch({ type: GlobalAction.SessionReady });
    if (!available || access) ready();
    else void restore().finally(ready);
  }, [access, available, restore, dispatch]);

  return null;
}
